export default __webpack_public_path__ + "static/media/input-by-category.912e9c72.svg";